import { FC } from 'react';

import { Grid, Typography } from '@mui/material';

import { ITableSectionTitleProps } from './types';

import styles from './TableSectionTitle.module.scss';

export const TableSectionTitle: FC<ITableSectionTitleProps> = ({ title, maxWidth = 210 }) => {
  return (
    <Grid item xs className={styles.sticky}>
      <Typography sx={{ maxWidth }} variant="subtitle2" className={styles.title}>
        {title}
      </Typography>
    </Grid>
  );
};
